import { useState } from 'react';
import { Icon } from '../../../components/Icons.jsx';

export function ChipInput({ value = [], onChange, placeholder = 'Add and press Enter', disabled = false }) {
  const [draft, setDraft] = useState('');

  function commit(raw) {
    const next = String(raw || '').trim();
    if (!next) return;
    if (value.includes(next)) {
      setDraft('');
      return;
    }
    onChange?.([...value, next]);
    setDraft('');
  }

  function handleKey(event) {
    if (event.key === 'Enter' || event.key === ',') {
      event.preventDefault();
      commit(draft);
    } else if (event.key === 'Backspace' && !draft && value.length) {
      onChange?.(value.slice(0, -1));
    }
  }

  function remove(index) {
    onChange?.(value.filter((_, i) => i !== index));
  }

  return (
    <div className={`cp-chip-input ${disabled ? 'is-disabled' : ''}`}>
      {value.map((item, index) => (
        <span key={`${item}-${index}`} className="chip cp-chip-tag">
          {item}
          <button
            type="button"
            onClick={() => remove(index)}
            className="cp-chip-remove"
            aria-label={`Remove ${item}`}
          >
            <Icon name="x" size={10} />
          </button>
        </span>
      ))}
      <input
        type="text"
        value={draft}
        onChange={(event) => setDraft(event.target.value)}
        onKeyDown={handleKey}
        onBlur={() => commit(draft)}
        placeholder={value.length ? '' : placeholder}
        disabled={disabled}
        className="cp-chip-text"
      />
    </div>
  );
}
